import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { HXToggleSwitchEl } from "./HXToggleSwitch.styles";
export const HXToggleSwitch = (props) => {
    return _jsx(HXToggleSwitchEl, { ...props });
};
